import React from 'react';
import { xconnect } from '../../redux/xconnect';
import PropTypes from 'prop-types';
import {
  setCrossDeviceDocumentLoaded,
  setDocumentDataUrl,
  setScanEnded
} from '../../redux/actions/rootAction';
import {
  getBase64FromUrl,
  extBase642LocalURL,
  putFileBySignedUrl
} from '../../lib/fileUtils';
import PaperflyAPI from '../../server/api/PaperflyAPI';
import { gaeApp } from './Analytics';

const PAGE_ID_PLACEHOLDER = 'PAGE_ID_PLACEHOLDER';

export default function withCrossDeviceDocument(WrappedComponent) {
  // noinspection JSPotentiallyInvalidUsageOfThis
  class WrapperClass extends React.Component {
    uploadImagesToCrossDeviceDocumentsStorage = async (
      pagesIdUrlMap,
      putUrl
    ) => {
      gaeApp('CROSS_DEVICE.UPLOAD_IMAGES_BY_PUT_URL');
      for await (let [pageId, url] of pagesIdUrlMap) {
        const base64 = await getBase64FromUrl(url);
        await putFileBySignedUrl(
          putUrl.replace(PAGE_ID_PLACEHOLDER, pageId),
          'image/*',
          base64
        ).then(
          success => true,
          error => false
        );
      }
    };

    completeCrossDeviceDocumentRequest = async (
      pagesIdUrlMap,
      documentOptions
    ) => {
      gaeApp('CROSS_DEVICE.START_COMPLETE');
      await this.uploadImagesToCrossDeviceDocumentsStorage(
        pagesIdUrlMap,
        this.props.crossDeviceRequest.putUrl
      );
      return PaperflyAPI.crossDeviceDocumentComplete(
        this.props.crossDeviceRequest.crossDeviceId,
        Array.from(pagesIdUrlMap.keys()),
        documentOptions
      ).then(
        () => {
          gaeApp(
            'CROSS_DEVICE.SET_SCAN_ENDED_AFTER_CROSS_DEVISE_COMPLETE',
            'TRUE'
          );
          this.props.setScanEnded();
          return true;
        },
        () => false
      );
    };

    downloadImagesFromCrossDeviceDocumentsStorage = async (
      pagesIdArray,
      documentId,
      downloadUrl
    ) => {
      gaeApp(
        'CROSS_DEVICE.GET_IMAGES_BY_DOWNLOAD_URL',
        JSON.stringify(pagesIdArray)
      );

      for (const pageId of pagesIdArray) {
        gaeApp('CROSS_DEVICE.DOWNLOAD_PAGE', pageId);
        const localUrl = await extBase642LocalURL(
          downloadUrl.replace(PAGE_ID_PLACEHOLDER, pageId)
        );
        if (localUrl) {
          this.props.setDocumentDataUrl(documentId, pageId, localUrl);
        } else {
          gaeApp('CROSS_DEVICE.ERROR_ON_DOWNLOAD_PAGE', pageId);
        }
      }
    };

    prepareCrossDeviceRequestImages = (pagesIdArray, documentId) => {
      gaeApp('CROSS_DEVICE.PREPARE_AND_CHECK_ALREADY_UPLOADED_IMAGES');
      return this.downloadImagesFromCrossDeviceDocumentsStorage(
        pagesIdArray,
        documentId,
        this.props.crossDeviceRequest.downloadUrl
      );
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          completeCrossDeviceDocumentRequest={
            this.completeCrossDeviceDocumentRequest
          }
          uploadImagesToCrossDeviceDocumentsStorage={
            this.uploadImagesToCrossDeviceDocumentsStorage
          }
          downloadImagesFromCrossDeviceDocumentsStorage={
            this.downloadImagesFromCrossDeviceDocumentsStorage
          }
          prepareCrossDeviceRequestImages={this.prepareCrossDeviceRequestImages}
        />
      );
    }
  }

  WrapperClass.propTypes = {
    crossDeviceRequest: PropTypes.object,
    setDocumentDataUrl: PropTypes.func.isRequired,
    setScanEnded: PropTypes.func.isRequired
  };

  const mapStateToProps = state => {
    return {
      crossDeviceRequest: state.crossDeviceRequest,
      crossDeviceDocumentLoaded: state.crossDeviceDocumentLoaded
    };
  };

  const mapDispatchToProps = dispatch => ({
    setDocumentDataUrl: (documentId, pageId, dataUrl) =>
      dispatch(setDocumentDataUrl(documentId, pageId, dataUrl)),
    setCrossDeviceDocumentLoaded: () =>
      dispatch(setCrossDeviceDocumentLoaded()),
    setScanEnded: () => dispatch(setScanEnded())
  });

  return xconnect(mapStateToProps, mapDispatchToProps)(WrapperClass);
}
